import React from 'react';
import { Link } from 'react-router-dom';

export default function NavItem({
  icon: Icon,
  label,
  active,
  onClick,
  to,
  badge,
  subItems,
  isCollapsed,
  theme,
}) {
  const isDark = theme === 'dark';
  const isActive = active;
  const itemColor = isActive ? (isDark ? '#FFFFFF' : '#111827') : (isDark ? '#A1A1AA' : '#5A5A65');
  const activeBg = isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)';
  const bg = isActive ? activeBg : 'transparent';

  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: isCollapsed ? 'center' : 'flex-start',
    gap: isCollapsed ? '0' : '14px',
    width: '100%',
    height: '40px',
    padding: isCollapsed ? '0' : '0 16px',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    border: 'none',
    borderLeft: isActive ? `3px solid ${isDark ? '#FFF' : '#111827'}` : '3px solid transparent',
    background: bg,
    color: itemColor,
    cursor: 'pointer',
    position: 'relative',
    outline: 'none',
    textDecoration: 'none',
    boxSizing: 'border-box',
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1), background 150ms ease, color 150ms ease',
  };

  const content = (
    <>
      {Icon && (
        <Icon
          size={20}
          strokeWidth={isActive ? 2.2 : 1.8}
          style={{ flexShrink: 0, color: itemColor }}
        />
      )}
      {!isCollapsed && (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </span>
      )}
      {badge && !isCollapsed && (
        <span style={{ marginLeft: 'auto' }}>
          {badge}
        </span>
      )}
    </>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      {to ? (
        <Link
          to={to}
          style={style}
          onMouseEnter={(e) => {
            if (!isActive && !isCollapsed) {
              e.currentTarget.style.transform = 'translateX(4px)';
            }
            if (!isActive) {
              e.currentTarget.style.background = isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isActive && !isCollapsed) {
              e.currentTarget.style.transform = 'translateX(0)';
            }
            if (!isActive) {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          {content}
        </Link>
      ) : (
        <button
          onClick={onClick}
          style={style}
          onMouseEnter={(e) => {
            if (!isActive && !isCollapsed) {
              e.currentTarget.style.transform = 'translateX(4px)';
            }
            if (!isActive) {
              e.currentTarget.style.background = isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isActive && !isCollapsed) {
              e.currentTarget.style.transform = 'translateX(0)';
            }
            if (!isActive) {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          {content}
        </button>
      )}
      {subItems && !isCollapsed && subItems}
    </div>
  );
}
